import CustomTemplateFormPreview from "../Components/Custom Template Form/CustomTemplateFormPreview";
import RenderFieldPreview from "../Components/Custom Template Form/RenderFieldPreview";
import RenderFieldPreviewWidget from "../Components/Custom Template Form/Encounter Widgets/RenderFieldPreview"; // just to add it as unique component imported as RenderFieldWidget
import isNull from "../../../../../../../../utils/NullChecking";

const AIEncounterTranscriptPreview = ({
    generatedNotes: Data
    // selectedItems, data, Data, searchParam, searchValue, ...props
}) => {
    // let { showAddressTypeLocation } = props;
    let count = 0;
    const excludedNames = ["Heading", "TextField", "Divider"];

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }

    const removeTrailingEmptyLines = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }

    let noValExistTextNA = <p className="text ar-light-color">N/A</p>;
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;


    let historyOfPresentIllnessData = Data?.HistoryOfPresentIllness;
    let reviewOfSystemData = Data?.ReviewOfSystem;

    let historyofPresentIllnessNotesText = removeTrailingEmptyLines(Data?.HistoryofPresentIllnessNotes || '');
    let reviewOfSystemNotesText = removeTrailingEmptyLines(Data?.ReviewOfSystemNotes || '');

    const CustomTemplateData = Data?.CustomTemplateData?.[0];
    const MainCustomTemplateData = Data?.MainCustomTemplate?.[0];

    const procedureCodesWidgetPreviewProps = {
        Data: Data,
    };

    let dataItems = MainCustomTemplateData?.Data?.[0]?.items;
    let widgetsPreviewData = {
        ...Data,
        dataVital: Data?.Vital,
        searchParamVitalUnitType: Data?.Data?.VitalUnitType,
        isOpenedFromSelectedModal: "false"
    }
    console.log("MainCustomTemplateData ToSaveDataAI ", Data, MainCustomTemplateData)
    return (<>
        <div className="d-flex flex-column gap-10">
            {dataItems && dataItems?.length > 0 ?
                <div className="Form-import-edit-view d-flex flex-column gap-30">
                    <div className="ar_pat-info-form-fill h-auto">
                        <div className="ar_fill-content-box p-0 w-auto">
                            <div className="ar-intake-form-fill ar_star-form-Preview">
                                <div className="Form-content d-flex flex-column gap-2 h-100 p-0 overflow-visible">
                                    {dataItems.map(it => {
                                        const shouldCount = !excludedNames.some(name => it?.ItemID?.includes(name));
                                        const itemCount = shouldCount ? ++count : null;
                                        let itemID = !isNull(it?.ItemID) ? it?.ItemID?.split('-')[0] : ''
                                        if (itemID === 'FormattingTextField') return null;
                                        if (it?.IsWidget === "true") {
                                            // const isItemProcedureCodes = (it?.ItemID?.startsWith('ProcedureCodes'));
                                            // return <RenderFieldPreviewWidget 
                                            //     item={it}
                                            //     widgetsPreviewData={widgetsPreviewData} 
                                            //     procedureCodesWidgetPreviewProps={isItemProcedureCodes ? procedureCodesWidgetPreviewProps : {}}
                                            //     itemCount={itemCount}/>
                                            return null
                                        }
                                        return <RenderFieldPreview item={it} activeAccordion={MainCustomTemplateData?.key || 'Intake Form'} patientName={'PatientName'} itemCount={itemCount} />
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <p className="text ar-light-color">No data recorded</p>}
        </div>
    </>)
}
export default AIEncounterTranscriptPreview